const key = "IksHeR6Vmf-gigz";

export const getLocalToken = (customKey = key) => {
  return localStorage.getItem(customKey) || "";
};

export const setLocalToken = (token, customKey = key) => {
  return localStorage.setItem(customKey, token);
};

export const clearLocalToken = (customKey = key) => {
  return localStorage.removeItem(customKey);
};
